import React from "react";

import useAuth from "../../../hooks/useAuth";
import FilterProjectAndWarehouse from "./FilterProjectAndWarehouse";
import FilterClientAndProject from "./FilterClientAndProject";

export default function Filter({
  onSelectProject,
  onSelectClient,
  clientId,
  projectId,
  md,
  hideActions,
}) {
  const { user } = useAuth();
  const { settings } = user.company;
  const warehouseDropdownEnabled = settings.warehouse_id_dropdown_menu;

  if (warehouseDropdownEnabled) {
    return (
      <FilterProjectAndWarehouse
        onSelectProject={onSelectProject}
        projectId={projectId}
        md={md}
        hideActions={hideActions}
      />
    );
  }

  return (
    <FilterClientAndProject
      onSelectProject={onSelectProject}
      onSelectClient={onSelectClient}
      clientId={clientId}
      projectId={projectId}
      md={md}
      hideActions={hideActions}
    />
  );
}
